import postOrder from './postOrder';

export default {
  postOrder,
};



// WEBPACK FOOTER //
// ./src/api/orders/actions/index.js